export const USER_DETAILS = 'USER_DETAILS';

export const SET_COORDS = 'SET_COORDS';
export const SET_INTITIAL_POSITION = 'SET_INITIAL_POSITION';

export const SET_INFO_TOGGLE = 'SET_INFO_TOGGLE';
export const SET_CENTER_EN = 'SET_CENTER_EN';

export const SET_COMMUTER_TRAVEL_DATA = 'SET_COMMUTER_TRAVEL_DATA';
export const SET_DRIVER_TRAVEL_DATA = 'SET_DRIVER_TRAVEL_DATA';

export const SET_POSTS_LIST = 'SET_POSTS_LIST';
export const SET_BUS_STOPS_LIST = 'SET_BUS_STOPS_LIST'

export const SET_DRIVER_ROUTE = 'SET_DRIVER_ROUTE';
export const SET_DRIVER_DESTINATION = 'SET_DRIVER_DESTINATION';

export const SET_NEON_ASSISTANT_STATUS = 'SET_NEON_ASSISTANT_STATUS';

export const SET_LIVE_BUS_LIST = 'SET_LIVE_BUS_LIST';